import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    mb: 1.5,
    flex: 1,
  },
  tagContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '0.5px solid',
    borderColor: 'common.border',
    backgroundColor: 'common.lightGreen',
    px: 2,
    py: '4px',
    borderRadius: 10,
  },
  workshift: {
    backgroundColor: 'eventChip.posted',
  },
  requested: {
    backgroundColor: 'eventChip.requested',
  },
  booked: {
    backgroundColor: 'eventChip.booked',
  },
  logo: {
    height: 20,
    width: 20,
    borderRadius: 10,
    marginRight: 5,
    border: '0.5px solid',
    borderColor: ThemeConstants.common.border,
    backgroundColor: ThemeConstants.secondary.main,
  },
  tag: {
    fontSize: 12,
    fontWeight: '500',
    color: 'footer.verticalLine',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
